import { createFileRoute } from '@tanstack/react-router';
import { AuthCard, AuthShell } from '@/features/auth/layout/auth-layout';
import { LoginForm } from '@/features/auth/forms/login-form';
import { RedirectIfAuthed } from '@/features/auth/components/redirect-if-authed';
import { sanitizeRedirect } from '@/features/auth/validators/redirect-search';

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect:
      typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: LoginPage,
});

function LoginPage() {
  const { redirect } = Route.useSearch();

  return (
    <RedirectIfAuthed>
      <AuthShell brandPane>
        <AuthCard title="Connexion">
          <LoginForm redirectTo={sanitizeRedirect(redirect)} />
        </AuthCard>
      </AuthShell>
    </RedirectIfAuthed>
  );
}
